import { PageName } from '@/enums/pageName'

export const pagesOrder: PageName[] = [
  PageName.age,
  PageName.audience,
  PageName.mainGoal,
  PageName.physicalBuild,
  PageName.dreamBody,
  PageName.areasToFocus,
  PageName.trainingExperience,
  PageName.lastIdealWeigh,
  PageName.pilatesExperience,
  PageName.flexibility,
  PageName.workout,
  PageName.shortnessOfBreath,
  PageName.walkingFrequency,
  PageName.struggle,
  PageName.workSchedule,
  PageName.describeYourDay,
  PageName.energyLevels,
  PageName.sleepRoutine,
  PageName.waterIntake,
  PageName.breakfast,
  PageName.lunch,
  PageName.dinner,
  PageName.diet,
  PageName.badHabits,
  PageName.weightOnEvents,
  PageName.height,
  PageName.weight,
  PageName.weightGoal,
  PageName.age2,
  PageName.name,
  PageName.profile,
  PageName.event,
  PageName.eventDate,
  PageName.weightLossProgram,

  PageName.preparingPlan,

  PageName.warmUpScreen,

  PageName.selectPlan,
  PageName.paymentFailed,
  PageName.preLtp,

  PageName.selectLTP,
  PageName.paymentSuccess,
  PageName.ltpPaymentFailed,
]
